import React, { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { CloseIcon } from "../../../components/Icons";
import { useModal } from "../../../context/ModalContext";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";

const scratchPayLogo = "/assets/icons/scratchpay.png";

const PaymentInformationModal = () => {
  const { closeModal } = useModal();

  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.SCRATCHPAY_INFO_MODAL_VIEWED, {});
  }, []);

  return (
    <Box className="relative w-full">
      <Box className="flex justify-end mb-4">
        <Box
          className="bg-gray-6 rounded-full p-1 cursor-pointer"
          onClick={closeModal}
        >
          <CloseIcon className="text-light-black" />
        </Box>
      </Box>

      <Box className="overflow-y-auto flex flex-col gap-4 items-center w-full">
        <Typography
          variant="h3"
          className="font-semibold !text-2xl !leading-7 text-center w-full"
          sx={{ color: "black.main" }}
        >
          Payment Plan Options
        </Typography>

        <Box
          className="flex flex-col gap-3 items-center justify-center p-4 rounded-lg w-full"
          sx={{
            backgroundColor: "whiteWarm.main",
            border: "1px solid",
            borderColor: "sand.main",
          }}
        >
          <Box className="flex flex-col gap-0.5 items-center justify-center w-full text-center">
            <Typography
              variant="body1"
              className="font-semibold !text-base !leading-6"
              sx={{ color: "black.main" }}
            >
              One-time Annual Payment
            </Typography>
            <Typography
              variant="body2"
              className="!font-geograph-regular !text-sm !leading-5"
              sx={{ color: "black.main" }}
            >
              Save when you make an annual wellness plan payment.
            </Typography>
          </Box>
        </Box>

        <Box
          className="flex flex-col gap-3 items-center justify-center p-4 rounded-lg w-full"
          sx={{
            backgroundColor: "whiteWarm.main",
            border: "1px solid",
            borderColor: "sand.main",
          }}
        >
          <Box className="flex items-center justify-center h-[33px]">
            <img
              src={scratchPayLogo}
              alt="ScratchPay"
              className="h-full w-auto object-contain"
            />
          </Box>
          <Box className="flex flex-col gap-0.5 items-start w-full text-center">
            <Typography
              variant="body1"
              className="font-semibold !text-base !leading-6 w-full"
              sx={{ color: "black.main" }}
            >
              Monthly Payments with ScratchPay
            </Typography>
            <Typography
              variant="body2"
              className="!font-geograph-regular !text-sm !leading-5 w-full"
              sx={{ color: "black.main" }}
            >
              Pay in smaller installments each month for the 12 months of your plan.
            </Typography>
          </Box>
        </Box>

        <Button
          variant="contained"
          fullWidth
          onClick={closeModal}
          className="!rounded-full !py-4 !px-8"
          sx={{
            "backgroundColor": "primary.main",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
            "textTransform": "none",
          }}
        >
          <Typography
            className="font-semibold !text-sm !leading-[14px]"
            sx={{ color: "black.main" }}
          >
            Got it
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default PaymentInformationModal;

